import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireSession } from '../lib/auth-guard'

export const Route = createFileRoute('/organizations')({
  // Org-less, so outside the $org guard: a signed-out visitor goes to the
  // login page and comes back here (spec 2026-10-14-16).
  beforeLoad: ({ location }) => requireSession(undefined, location.href),
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
